@if (state()) {
    <!-- #region hero -->
    @if (this.product()) {
        <app-hero
            id="hero-image"
            [imagePath]="product().presentation.imageUrl"
            [imageAlt]="product().presentation.imageAlt"
            [headline]="product().presentation.imageHeadline"
        />
    }
    <!-- #endregion -->

    <!-- #region main template -->
    <div id="order-container">
        @if (isLandingPage()) {
            <app-landing-page-container
                [state]="state()"
                (next)="next($event)"
            />
        } @else {
            <div class="content-container p-24:v md:p-32:v lg:p-48:v">
                <div class="grid-container">
                    <!-- #region form order form steps -->
                    <div class="g-12 md:g-8">
                        @if (price()) {
                            <app-price-display-card
                                class="block md:hide m-48:b"
                                [price]="price()"
                                [settlementPeriod]="insuranceType()?.settlementPeriod"
                                [taxInfo]="product()?.orderConfig.taxInfo"
                                bannerText="Gewählter Tarif"
                            />
                        }
                        @for (step of product().orderConfig.steps | slice: 1; track $index) {
                            <app-step-toggle
                                [open]="state().currentStep === step.slug"
                                [complete]="isComplete(step.slug)"
                                [state]="state()"
                                [previousStepComplete]="isPreviousStepComplete(step.slug)"
                                [stepCounter]="$index + 1"
                                [orderStep]="step"
                                (prev)="prev($event)"
                                (next)="next($event)"
                                (close)="onClose($event)"
                                (clicked)="toggle($event)"
                            />
                        }
                    </div>
                    <!-- #endregion -->
                    <!-- #region sidebar -->
                    <div class="g-12 md:g-4">
                        <app-order-summary
                            class="m-24:b block"
                            [state]="state()"
                        />
                    </div>
                    <!-- #endregion -->
                </div>
            </div>
        }
    </div>
    <!-- #endregion -->
}
